var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGemini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#EF5252"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7887 13.3389V6.59761C12.8385 6.23377 13.5187 5.54225 13.5187 4.71287C13.5187 4.41908 13.2972 4.18066 13.0249 4.18066C12.7526 4.18066 12.5311 4.41908 12.5311 4.71287C12.5311 5.16033 11.5594 5.80891 10.0362 5.80891C8.51303 5.80891 7.54128 5.1592 7.54128 4.71287C7.54128 4.41908 7.31981 4.18066 7.0475 4.18066C6.77518 4.18066 6.55371 4.41908 6.55371 4.71287C6.55371 5.54225 7.23394 6.23377 8.28365 6.59761V13.3389C7.23394 13.7027 6.55371 14.3942 6.55371 15.2236C6.55371 15.5174 6.77518 15.7558 7.0475 15.7558C7.31981 15.7558 7.54128 15.5174 7.54128 15.2236C7.54128 14.7761 8.51303 14.1276 10.0362 14.1276C11.5594 14.1276 12.5311 14.7773 12.5311 15.2236C12.5311 15.5174 12.7526 15.7558 13.0249 15.7558C13.2972 15.7558 13.5187 15.5174 13.5187 15.2236C13.5187 14.3942 12.8385 13.7027 11.7887 13.3389ZM9.4441 13.0925V6.84394C9.6362 6.86315 9.83281 6.87445 10.0373 6.87445C10.2418 6.87445 10.4385 6.86315 10.6305 6.84394V13.0925C10.4385 13.0733 10.2418 13.062 10.0373 13.062C9.83281 13.062 9.6362 13.0733 9.4441 13.0925Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGemini);
export default __webpack_public_path__ + "static/media/gemini.f0ef90bea23e392119adbd5fbf548d83.svg";
export { ForwardRef as ReactComponent };